import { graphql, useStaticQuery } from 'gatsby';

const useAuthorsMetadata = () => {
  const { authors } = useStaticQuery(graphql`
            query {
                authors: allContentfulAuthors {
                  nodes {
                    slug
                    firstName
                    lastName
                    profilePicture {
                      description
                      file {
                        contentType
                        url
                        fileName
                      }
                      gatsbyImageData
                      svg {
                        content
                      }
                    }
                  }
                }
            }
            `
  );
  return authors;
};

export default useAuthorsMetadata;